<!-- AppFooter.vue -->
<template>
  <footer class="app-footer">
    <div class="footer-container">
      <div class="footer-content">
        <div class="footer-brand">
          <h3 class="company-name">Self Gens LLC</h3>
        </div>
        
        <div class="footer-grid">
          <!-- Contact information -->
          <div class="footer-section">
            <h6 class="footer-heading">Contact</h6>
            <ul class="footer-list">
              <li><a href='tel:+17257801484'>+1 725-780-1484</a></li>
              <li><a href="mailto:contact@selfgens.com">contact@selfgens.com</a></li>
            </ul>
          </div>
          
          <!-- Social media links -->
          <div class="footer-section">
            <h6 class="footer-heading">Social</h6>
            <div class="social-links">
              <a href="https://www.instagram.com/self.gens/" class="social-link" aria-label="Instagram">
                <i class="ic ic-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/company/self-gens-llc" class="social-link" aria-label="LinkedIn">
                <i class="ic ic-linkedin"></i>
              </a>
              <a href="https://www.facebook.com/profile.php?id=100089297723788" class="social-link" aria-label="Facebook">
                <i class="ic ic-facebook"></i>
              </a>
            </div>
          </div>
          
          <!-- Legal information -->
          <div class="footer-section">
            <h6 class="footer-heading">Legal</h6>
            <ul class="footer-list">
              <li><router-link to="/terms-and-conditions">Terms Of Use</router-link></li>
              <li><router-link to="/privacy-policy">Privacy Policy</router-link></li>
            </ul>
          </div>
          
          <!-- Blog links -->
          <div class="footer-section">
            <h6 class="footer-heading">Blogs</h6>
            <ul class="footer-list">
              <li v-for="(blog, index) in blogs" :key="index">
                <router-link :to="blog.url">{{ blog.title }}</router-link>
              </li>
            </ul>
          </div>
        </div>
        
        <!-- Copyright notice -->
        <div class="footer-copyright">
          <p>&copy; {{ currentYear }} Self Gens, LLC</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="js">
export default {
  name: 'AppFooter',
  data() {
    return {
      blogIds: [
        "can-solar-panel-systems-combat-inflation",
        "three-reasons-why-solar-is-good-for-the-consumer",
        "mono-vs-poly-panels",
      ],
      blogs: [
        { 
          id: "can-solar-panel-systems-combat-inflation",
          title: "Can Solar Panel Systems Combat Inflation?",
          url: "/blog/can-solar-panel-systems-combat-inflation"
        },
        { 
          id: "three-reasons-why-solar-is-good-for-the-consumer",
          title: "Three Reasons Why Solar is Good for Consumers",
          url: "/blog/three-reasons-why-solar-is-good-for-the-consumer"
        },
        { 
          id: "mono-vs-poly-panels",
          title: "Mono vs Poly Panels: What's the Difference?",
          url: "/blog/mono-vs-poly-panels"
        }
      ]
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    async loadBlogData() {
      try {
        // Here you would typically fetch blog data from an API or service
        console.log('Blog data loaded');
      } catch (error) {
        console.error('Error loading blog data:', error);
      }
    }
  },
  mounted() {
    this.loadBlogData();
  }
}
</script>

<style scoped>
.app-footer {
  background-color: var(--sg-dark);
  color: var(--sg-light);
  padding: 3rem 0 2rem;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.footer-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.company-name {
  font-size: 1.8rem;
  font-weight: 800;
  margin: 0;
  color: var(--sg-light);
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
}

.footer-heading {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  margin-bottom: 1rem;
  color: var(--sg-light);
}

.footer-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-list li {
  margin-bottom: 0.5rem;
}

.footer-list a {
  font-size: 0.8rem;
  color: var(--sg-light);
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.footer-list a:hover {
  opacity: 0.8;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  color: var(--sg-light);
  transition: all 0.3s ease;
}

.social-link:hover {
  background: var(--primary-color);
  transform: translateY(-2px);
}

.footer-copyright {
  text-align: center;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-weight: 700;
}

/* Theme-specific styles */
.theme-glass .app-footer {
  background-color: rgba(31, 47, 47, 0.7);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.theme-glass .social-link {
  background: rgba(255, 255, 255, 0.2);
}

.theme-glass .social-link:hover {
  background: rgba(var(--primary-color-rgb), 0.7);
}

.theme-dark .app-footer {
  background-color: var(--sg-dark);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .footer-grid {
    grid-template-columns: 1fr;
  }
}
</style>